import { Link } from 'react-router-dom'

const OpenPricesButton = ({ language }) => {
  return (
    <div
      className="text-xl border max-w-max mx-auto py-2 px-3 rounded-lg text-white bg-[#002998ef] hover:scale-105 duration-300"
      onClick={() => window.scrollTo({ top: 0 })}
    >
      <Link to="../prices">
        {language
          ? 'Відкрити повний перелік послуг із цінами'
          : 'Open full list of services with prices'}
      </Link>
    </div>
  )
}

export default OpenPricesButton
